<div
  class="h-full bg-[#eaeef3] relative"
  id="suggestions-main"
  tabindex="0"
  (blur)="onBlurSuggestions()"
  (focus)="onFocusSuggestions()"
>
  <div class="mt-[45px] z-[6] text-xs flex flex-nowrap flex-col items-center absolute w-full">
    @if (error()) {
      <div
        class="font-semibold flex items-center max-w-[80%] min-w-[50%] min-h-8 max-h-[150px] rounded bg-red-500 shadow-md mt-2.5 text-white"
        role="alert"
        [@fadeInOut]
      >
        <div class="flex-1 px-[15px] py-1.5 leading-5 overflow-hidden justify-center flex items-center">
          {{ error() | translate }}
        </div>
        <button
          type="button"
          class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] flex items-center"
          [attr.aria-label]="'cl_chat.close' | translate"
          (click)="clearError()"
        >
          <i class="mi2-close text-sm text-surface-0"></i>
        </button>
      </div>
    }
    @if (unReadMessages() > 0 && !loading()) {
      <div
        class="font-semibold flex items-center max-w-[80%] min-w-[50%] min-h-8 max-h-[150px] rounded bg-blue-600 shadow-md mt-2.5 text-white"
        role="status"
      >
        <button
          type="button"
          class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] flex items-center"
          [attr.aria-label]="'cl_chat.scrollToBottom' | translate"
          (click)="scrollToBottom()"
        >
          <i class="mi2-arrow-down text-[16px] text-primary"></i>
        </button>
        <div
          class="flex-1 px-[15px] py-1.5 leading-5 overflow-hidden justify-center flex items-center"
          translate
          [translateParams]="{ total: unReadMessages() }"
        >
          ai_suggestions.new_messages
        </div>
        <button
          type="button"
          class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] flex items-center"
          [attr.aria-label]="'cl_chat.close' | translate"
          (click)="unReadMessages.set(0)"
        >
          <i class="mi2-close text-sm text-surface-0"></i>
        </button>
      </div>
    }
  </div>

  <div
    #activesuggestionscontent
    (blur)="onBlurSuggestions()"
    (focus)="onFocusSuggestions()"
    class="h-full overflow-y-auto"
    [ngStyle]="{ display: selectedTabIndex() === 0 ? 'block' : 'none' }"
  >
    @if (!loading()) {
      <div class="bg-[#bdc1c5] w-full text-right pr-5 pt-[5px] pb-[5px] absolute opacity-0 hover:opacity-100 z-10">
        <div style="width: 16px; float: right">
          <button
            type="button"
            class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)]"
            [attr.aria-label]="'ai_suggestions.tooltips.collapse_all' | translate"
            [pTooltip]="'ai_suggestions.tooltips.collapse_all' | translate"
            tooltipPosition="left"
            (click)="collapseAll()"
          >
            <i class="mi2-triangle-arrows text-[16px] cursor-pointer text-surface-600"></i>
          </button>
        </div>
      </div>
    }
    @if (loading()) {
      <div class="h-full w-full bg-surface-50 flex-1">
        <ng-container *ngTemplateOutlet="loadingTemplate"> </ng-container>
      </div>
    }
    @if (!loading()) {
      <div>
        @for (s of suggestions(); track s) {
          <div>
            @if (!s.archived) {
              <chat-suggestion-item
                [item]="s"
                (archive)="archiveSuggestion(s)"
                [locale]="locale()"
                (loadSuggestionAttachment)="loadSuggestionAttachment(s)"
                (goTo)="onGoToChatMessage(s.body.parentMessageId)"
                (send)="onSendSuggestion($event, s)"
                (feedback)="onFeedback($event, s)"
                (opened)="onOpened($event, s)"
              >
              </chat-suggestion-item>
            }
          </div>
        }
        @if (!loading() && !activeSuggestions.length) {
          <div class="font-semibold leading-[1.5] text-color inline-block w-full text-center mt-[15px]">
            {{ 'ai_suggestions.no_suggestions' | translate }}
          </div>
        }
      </div>
    }
  </div>
</div>

<ng-template #loadingTemplate>
  <div>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-2"></div>
        <div class="ph-col-10 empty"></div>
        <div class="ph-col-4 big"></div>
        <div class="ph-col-8 big empty"></div>
      </div>
    </div>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-1"></div>
        <div class="ph-col-11 empty"></div>
        <div class="ph-col-8 big"></div>
        <div class="ph-col-4 big empty"></div>
      </div>
    </div>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-1"></div>
        <div class="ph-col-11 empty"></div>
        <div class="ph-col-10 big"></div>
        <div class="ph-col-2 big empty"></div>
      </div>
    </div>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-2"></div>
        <div class="ph-col-10 empty"></div>
        <div class="ph-col-6 big"></div>
        <div class="ph-col-6 big empty"></div>
      </div>
    </div>
  </div>
</ng-template>
